import NewsArticle from './NewsArticle.vue';
export default {
  components: {
    NewsArticle
  },
  props: {
    tabList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      activeKey: '0',
      articleList: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      loading: true,
      disabled: false
    };
  },
  created() {
    this.getNewsList();
  },
  methods: {
    async getNewsList() {
      const params = {
        news_type: this.activeKey,
        page: this.pageIndex,
        per: this.pageSize
      };
      const {
        result
      } = await this.$http.news.getNewsList(params);
      this.loading = false;
      this.disabled = false;
      this.articleList = result.data;
      this.total = result.count;
    },
    handleTabChange(key) {
      this.disabled = true;
      this.activeKey = key;
      this.getNewsList();
    },
    handlePageChange(pageIndex, pageSize) {
      this.pageIndex = pageIndex;
      this.pageSize = pageSize;
      this.getNewsList();
    },
    handleSizeChange(current, size) {
      this.pageSize = size;
      this.getNewsList();
    }
  }
};